import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material/styles';

import Box from '~/common/components/Box';
import Text from '~/common/components/Texts/Text';
import colors from '~/theme/colors';

export const StyledTextBox = styled<any>(Text)`
  color: colors.gray[900];
  font-style: normal;
  display: flex;
  line-height: 1rem;
  font-size: 0.75rem;
  font-weight: 400;
  white-space: break-spaces;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  overflow: hidden;
`;

export const StyledCopyableBox = styled<any>(Box)`
  max-width: unset;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  & .faCopy-icon {
    color: transparent;
  }

  &:hover .faCopy-icon {
    color: ${colors.gray[900]};
  }

  &:active .faCopy-icon {
    color: ${colors.uwmOrange[500]};
  }

  &:hover {
    color: ${colors.gray[900]};
    background-color: ${colors.orange[100]};
    border-radius: 0.25rem;
  }

  &:active {
    color: ${colors.uwmOrange[500]};
  }

  &:focus {
    color: ${colors.orange[300]};
  }
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  padding-left: 0.25rem;
  margin-left: 0.25rem;
  padding-right: 0.25rem;
  margin-right: 0.25rem;
`;

export const tooltipStyle = {
  backgroundColor: colors.gray[800],
  lineHeight: '0.875rem',
  fontSize: '0.625rem',
  color: colors.white,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: '0.25rem',
};

export const arrowStyle = {
  color: colors.gray[800],
};
